import styled from "styled-components";
import CloseIcon from "@mui/icons-material/Close";
import {
  useFetchEntities,
  useRemoveOmittedRoleFromTourGroup,
} from "@/reactQueryHooks";

const BadgeContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 6px 10px;
  border-radius: 18px;
  background-color: #ffebee;
  color: #c62828;
  font-size: 12px;
  font-weight: 500;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.06);
  gap: 6px;
  transition: all 0.2s ease;

  &:hover {
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  }
`;

const RoleName = styled.div`
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 11px;
`;

const RemoveIconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.6);
  cursor: pointer;
  flex-shrink: 0;
  margin-left: 2px;

  &:hover {
    background-color: rgba(255, 255, 255, 0.8);
  }

  svg {
    font-size: 12px;
  }
`;

interface OmittedRoleBadgeProps {
  roleId: string;
  tourGroupId: string;
  refetch: () => void;
}

const OmittedRoleBadge = ({
  roleId,
  tourGroupId,
  refetch,
}: OmittedRoleBadgeProps) => {
  const { data: entities } = useFetchEntities() as any;
  const role = entities.data.roles.find((r: any) => r._id === roleId);

  const { mutateAsync: removeOmittedRoleToTourGroup } =
    useRemoveOmittedRoleFromTourGroup() as any;

  return (
    <BadgeContainer>
      <RoleName>{role?.title}</RoleName>
      <RemoveIconContainer
        onClick={async () => {
          try {
            await removeOmittedRoleToTourGroup({
              tour_group_id: tourGroupId,
              role_id: roleId,
            });
            refetch();
          } catch (error) {
            console.error("Error removing omitted role:", error);
            alert("Error. Please try again.");
          }
        }}
      >
        <CloseIcon color="error" />
      </RemoveIconContainer>
    </BadgeContainer>
  );
};

export default OmittedRoleBadge;
